import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DependenciaDto, VwSecDependencia } from '../../shared/interfaces/database/seguridad';
import { Page, PaginationParams, Utils } from 'lib-base';


@Injectable({
  providedIn: 'root'
})
export class SecDependenciaService {
  private readonly baseUrl = `${environment.apiUrl}/api/dependencia`;

  constructor(private http: HttpClient) { }

  getDependencias(params ?: PaginationParams): Observable<Page<VwSecDependencia>> {
    return this.http.get<Page<VwSecDependencia>>(`${this.baseUrl}`, { params: Utils.createPaginationParams(params) });
  }

  createDependencia(request: DependenciaDto): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  updateDependencia(id: number, request: DependenciaDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deleteDependencia(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  getIdDependenciaSisben(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/sisben`);
  }
}
